import { render, staticRenderFns } from "./RetencionConsulta.vue?vue&type=template&id=09fe83e5&scoped=true&"
import script from "./RetencionConsulta.vue?vue&type=script&lang=js&"
export * from "./RetencionConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe83e5",
  null
  
)

export default component.exports